import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler } from '../utils/http-error-handler';

export interface TenantIdentityConfigurationResponse {
  integrationBaseUrl: string;
  clientId: string;
  clientSecretKeyVaultName?: string;
  isClientSecretConfigured: boolean;
  azureAdTenantId?: string;
  callbackEndpointPath?: string;
  modifiedAtUtc?: string;
  createdAtUtc?: string;
}

export interface UpdateTenantIdentityConfigurationRequest {
  integrationBaseUrl: string;
  clientId: string;
  clientSecret?: string | null;
  azureAdTenantId?: string | null;
  callbackEndpointPath?: string | null;
}

@Injectable({ providedIn: 'root' })
export class TenantIdentityConfigurationService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/identity/configuration';

  getConfiguration(): Observable<TenantIdentityConfigurationResponse> {
    return this.http.get<TenantIdentityConfigurationResponse>(this.apiUrl).pipe(
      catchError((error: HttpErrorResponse) => HttpErrorHandler.handleError(error, 'Failed to load identity configuration'))
    );
  }

  updateConfiguration(request: UpdateTenantIdentityConfigurationRequest): Observable<TenantIdentityConfigurationResponse> {
    return this.http.put<TenantIdentityConfigurationResponse>(this.apiUrl, request).pipe(
      catchError((error: HttpErrorResponse) => HttpErrorHandler.handleError(error, 'Failed to save identity configuration'))
    );
  }
}
